/**
 * @version:               1.0.0
 * @createTime:            2021.10.09
 * @updateTime:            2021.10.09
 * @author:                zhangju
 * @description
 ***/

export default {
    name: 'zt-detail',
    data() {
        return {
            crumbsList: [],
            id: '',
            title:'',
            fbsj: '',
            fbdw: '',
            data: {ztlmVOList:[]}
        };
    },
    mounted() {
        this.init();
    },
    watch:{
        '$route.query.id':{
            handler() {
                this.changeCrumb();
            },
            immediate:true
        }
    },
    methods: {
        init() {
            console.log(111);
            console.log(this);
            console.log(111);
            this.changeCrumb();
            this.getData();
            this.initData();
            if (this.$route.query.fbdw) {
                this.fbdw = this.$route.query.fbdw;
            }
            if (this.$route.query.fbsj) {
                this.fbsj = this.$route.query.fbsj;
            }

        },
        changeCrumb() {
            this.id = this.$route.query.id || this.$route.query.bh;
        },
        // 轮播
        swipperInit() {
            $('#news_banner')
                .addBanner({
                    index: 0,
                    selectedClass: 'js-active',
                    classType: 'only',
                    mouseType: 'click',
                    container: '.swipper_container',
                    navContainer: '.nav_container',
                    nav: '.swipper_nav',
                    tweenTime: 2000,
                    effect:'fade1',
                    delay: 6000,
                    autoPlay: true,
                    isVertical: false,
                    isFullScreen: false,
                    callBack: this.siwpperCallback()
                });
        },
        setIter() {
            const _this = this;
            const dom = $('#xxxsd');
            this.timer = setInterval(() => {
                if (_this.top > -170) {
                    dom.css('transition', 'top 1s linear');
                    dom.css({top:_this.top - 56});
                    _this.top = _this.top - 56;
                    if (_this.top === -224) {
                        dom.css('transition', 'top 0s linear');
                        _this.top = 0;
                        dom.css('top', 0);
                        setTimeout(() => {
                            dom.css('transition', 'top 1s linear');
                            dom.css({top:_this.top - 56});
                            _this.top = _this.top - 56;
                        }, 2000);
                    }
                }
            }, 6000);
        },
        siwpperCallback() {
            this.$nextTick(() => {
                const TIME = 100;
                this.newsTimer = setInterval(() => {
                    this.activeImg = $('#news_footer')
                        .find('.js-active')
                        .index();
                }, TIME);
            });
        },
        initData() {
           // const bh = this.$route.query.bh;
            const bh ="93a1c0f571e4fc20c79aa001edef925e";

            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
               // url: window.fdConfig.url.zt.detail.replace('{id}', bh)
                url: window.fdConfig.url.zt.detail.replace('{id}',bh )
            }).then((res) => {
                if (res.data.zt) {
                    this.bt = res.data.zt.bt;
                    this.fbfw = res.data.zt.fbfw;
                    if (res.data.zt.fbdw) {
                        this.fbdw = res.data.zt.fbdw;
                    }
                    if (res.data.zt.fbsj) {
                        this.fbsj = res.data.zt.fbsj;
                    }
                }
            });
        },
        // 获取专题的文章
        getData() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
           //     url: window.fdConfig.url.zt.ztMessage.replace('{ztid}', this.id)
                url: window.fdConfig.url.zt.ztMessage_hssp.replace('{ztid}', "93a1c0f571e4fc20c79aa001edef925e" )

            }).then((res) => {
                this.data = res.data;
                this.$nextTick(() => {
                    this.setIter();
                });

                this.$nextTick(() => {
                    this.swipperInit();
                });
                $('#news_banner .some-specific-child').css('position', ''); // 替换为所需的值
                console.log(res.data);
            });
        },
        // 打开其他网站链接
        openUrl(url) {
            if (url) {
                window.open(url, '_blank');
            }
        },
        // 查看更多
        handleMore(item) {
            this.$router.push({
                path: '/yl/zt/more',
                query: {
                    lmid: item.ztlm.bh,
                    ztid:this.id,
                    lmmc: item.ztlm.lmmc,
                    ztmc:this.title,
                    fbdw: this.fbdw,
                    fbsj: this.fbsj
                }
            });
        },
        // 查看详情
        handleDetail(item) {
            const url = this.$router.resolve({path: '/zt/xqhssp', query: {active:'zt', id:item.bh, fbsj: this.fbsj, fbdw: this.fbdw}});
            window.open(url.href, '_blank');
        }
    }
};
//注释掉头部
$(document).ready(function() {
    if ($('#specific-page').length) { // 检查页面是否有这个元素
        $('.fd-top.noprint').hide();
        $('.fd-module-page').css('padding-top', '0px');
        // 注意：这里不需要再注释掉下面的代码了
    }

});

// $(document).ready(function() {
//     $('.fd-top.noprint').hide();
//   //  $('.fd-module-page').hide();
// });
